import React, { Component } from 'react';
import Item from './Item/index';
import styles from './index.less';

export default class DragList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
      columns: props.columns.filter(({ title }) => title !== '操作'),
    };

    this.handleHover = this.handleHover.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  // 将改变对象反馈传到后台
  handleChange() {
    const { handleSort } = this.props;
    const { data } = this.state;

    if (handleSort) {
      handleSort({ data });
    }
  }

  // hover的时候移动位置，不知道哪里配置不对 不在hover的时候移动位置并记录下最终移动到位置上的原本对象，那么拿不到上面那个对象
  handleHover(props, sourceItem) {
    const { data } = this.state;
    const { item: dropItem } = props; // 最终要落下位置的item的id
    const { userId: dropId } = dropItem;
    const { userId: dragId } = sourceItem; // 被拖动的item的id

    const dropIndex = data.findIndex(({ userId }) => userId === dropId);
    const dragIndex = data.findIndex(({ userId }) => userId === dragId);

    if (dropId !== dragId) {
      const [delItem] = data.splice(dropIndex, 1);
      data.splice(dragIndex, 0, delItem);

      this.setState({
        data,
      });
    }
  }

  // 渲染表头
  renderHeader = columns => {
    return (
      <div className="drag-list-header">
        {columns.map(({ title, dataIndex }) => {
          return (
            <div className="drag-list-header-item list-row-item" key={dataIndex}>
              {title}
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const { data, columns } = this.state;

    return (
      <div className={styles.root}>
        {this.renderHeader(columns)}
        <Item
          list={data.slice(0)}
          columns={columns}
          handleHover={this.handleHover}
          handleChange={this.handleChange}
        />
      </div>
    );
  }
}
